import type { ThemeConfig } from "antd";
import { melColors } from "./tokens";

/**
 * Tema antd (ConfigProvider) com a paleta AQUA/CIANO glassmorphism do MEL.
 * Aplicado em src/App.tsx envolvendo o <Refine> com <ConfigProvider theme={melTheme}>.
 */
export const melTheme: ThemeConfig = {
  token: {
    colorPrimary: melColors.aqua500,
    colorInfo: melColors.aqua500,
    colorSuccess: melColors.success,
    colorWarning: melColors.warning,
    colorError: melColors.error,
    colorTextBase: melColors.ink,
    colorLink: melColors.aqua600,
    colorLinkHover: melColors.aqua500,
    borderRadius: 12,
    fontFamily:
      "'Montserrat', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    wireframe: false,
  },
  components: {
    Layout: {
      // Header com gradiente é aplicado via style inline no Header custom; aqui
      // deixamos o sider e o body em superfícies de vidro.
      siderBg: "rgba(255, 255, 255, 0.62)",
      bodyBg: "transparent",
      headerBg: "transparent",
    },
    Menu: {
      itemSelectedBg: melColors.aqua100,
      itemSelectedColor: melColors.aqua700,
      itemHoverColor: melColors.aqua600,
      itemHoverBg: "rgba(6, 182, 212, 0.06)",
      itemBorderRadius: 10,
      itemMarginInline: 8,
      subMenuItemBg: "transparent",
      groupTitleColor: melColors.inkSoft,
    },
    Card: {
      borderRadiusLG: 16,
      colorBgContainer: "rgba(255,255,255,0.62)",
      headerFontSize: 15,
    },
    Button: {
      primaryShadow: "0 4px 16px rgba(6, 182, 212, 0.24)",
    },
    Table: {
      headerBg: "rgba(236, 254, 255, 0.7)",
      headerColor: melColors.ink,
      rowHoverBg: "rgba(6, 182, 212, 0.05)",
      borderColor: "rgba(45, 212, 191, 0.16)",
    },
    Tag: {
      borderRadiusSM: 8,
    },
    Statistic: {
      titleFontSize: 13,
    },
  },
};
